import React from 'react';
import classnames from 'classnames';
import Icon from "../Icon";
import ReactIs from 'react-is';
const defaultIcon = {
  success: /*#__PURE__*/React.createElement("div", {
    className: "cc-toast-icon success"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "chenggong"
  })),
  fail: /*#__PURE__*/React.createElement("div", {
    className: "cc-toast-icon fail"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "cuowu-2"
  })),
  info: /*#__PURE__*/React.createElement("div", {
    className: "cc-toast-icon info"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "zhuyi-1"
  })),
  loading: /*#__PURE__*/React.createElement("div", {
    className: "cc-toast-icon loading"
  }, /*#__PURE__*/React.createElement("img", {
    src: "https://cdn.calendar.tencent.com/calendar_res/c-loading.svg"
  }))
};
export const getIcon = opt => {
  if (opt.mode === 'normal' && opt.icon === 'loading') {
    return /*#__PURE__*/React.createElement("div", {
      className: "cc-toast-icon loading"
    }, /*#__PURE__*/React.createElement("img", {
      src: "https://cdn.calendar.tencent.com/calendar_res/c-loading-w.svg"
    }));
  }
  return defaultIcon[opt.icon] || opt.icon;
};
export const mergeOptions = options => {
  let opt = {
    mode: 'normal'
  };
  if (typeof options === 'string' || ReactIs.isValidElementType(options)) {
    opt = {
      ...opt,
      maskClassName: 'cc-toast',
      content: options
    };
  } else {
    opt = {
      ...opt,
      ...options,
      maskClassName: `cc-toast ${options?.maskClassName}`
    };
  }
  opt.icon = getIcon(opt);
  if (!opt.position) {
    opt.position = opt.mode === 'white' ? 'top' : 'center';
  }
  opt.maskClassName = classnames(opt.maskClassName, `cc-toast-${opt.mode}`, opt.position);
  return opt;
};